// @styling
import './loader.scss';

const Loader = () => {
  return (
    <div className='loader'>
      <span></span>
    </div>
  );
};

export default Loader;
